import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import Statistics from '../Plot/Statistics/Statistics';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';

interface StatisticsBoxProps {
  activePlotAnalytics: string | null;
  previewDatasetId: string;
  coordinates: number[];
  datasets: IBestDataset[];
  onDatasetChange: (value: string) => void;
  dateRange: any;
  enrichedMetadata: IEnrichedMetadata[];
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  statisticsImages: string;
  statisticsValuesLinks: string[];
  error: string;
  pointName: string;
  updating: boolean;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  point?: MarkerItem;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
}

const StatisticsBox: React.FC<StatisticsBoxProps> = ({
  activePlotAnalytics,
  previewDatasetId,
  coordinates,
  datasets,
  onDatasetChange,
  dateRange,
  enrichedMetadata,
  onUpdate,
  statisticsImages,
  statisticsValuesLinks,
  error,
  pointName,
  updating,
  userInput,
  updateUserInput,
  point,
  onChangeActiveKey,
  pointOption,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset,
}) => {
  if (activePlotAnalytics !== 'Statistics') {
    return null;
  }

  return (
    <Statistics
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      datasets={datasets}
      onDatasetChange={onDatasetChange}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      onUpdate={onUpdate}
      statisticsImages={statisticsImages}
      statisticsValuesLinks={statisticsValuesLinks}
      error={error}
      pointName={pointName}
      updating={updating}
      userInput={userInput}
      updateUserInput={updateUserInput}
      point={point}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}
    />
  );
};

export default StatisticsBox;
